import * as React from 'react'

import findIndex from 'lodash/findIndex'

import { observer } from 'mobx-react'

import createEffect from 'modules/core/hooks/createEffect'

import type Employee from 'modules/employees/store/models/Employee'
import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Items from './Items'
import * as styles from './index.vanilla.css'

export interface Props {
  employee: Employee
  planningVersion: PlanningVersion
}

const useOffsetRecalculation = createEffect(
  (
    setLeft: React.Dispatch<React.SetStateAction<number>>,
    getLeftOffset: (index: number) => number,
    selectedIndex: number
  ) => {
    setLeft(getLeftOffset(selectedIndex))
  }
)

const Navigator = ({ employee, planningVersion }: Props) => {
  const [left, setLeft] = React.useState(250)
  const rootEl = React.useRef<HTMLDivElement>(null)
  const planningVersions = usePlanningVersions()
  const sortedPlanningVersions = planningVersions.orderByEffectiveAt(employee.id)

  const selectedIndex = findIndex(
    sortedPlanningVersions,
    (item) => item.attributes.id === planningVersion.attributes.id
  )
  useOffsetRecalculation(setLeft, getLeftOffset, selectedIndex)

  function getLeftOffset(index: number): number {
    const el = rootEl.current

    if (!el) return 0

    return el.offsetWidth / 2 - 150 * index - 100
  }

  function onWheel(event: React.WheelEvent<HTMLDivElement>) {
    if (!event.deltaX) return

    const minLeft = getLeftOffset(0)
    const maxLeft = getLeftOffset(sortedPlanningVersions.length - 1)
    const value = left - event.deltaX
    setLeft(Math.min(Math.max(value, maxLeft), minLeft))
  }

  return (
    <div ref={rootEl} className={styles.root} onWheel={(event) => onWheel(event)}>
      <Items employee={employee} selectedPlanningVersion={planningVersion} left={left} />
    </div>
  )
}

export default observer(Navigator)
